import { AbstractControl, ValidationErrors } from "@angular/forms";

export function emailMandatoryValidator(): ValidationErrors | null {
  return (ctrl: AbstractControl) => {
    const isEmailMandatory = ctrl.get("isEmailMandatory")?.value;
    const emailChecked = ctrl.get("email")?.value;

    if (isEmailMandatory && !emailChecked) {
      return { emailRequired: true };
    }

    return null;
  };
}
